import { Component } from '@angular/core';

@Component({
  selector: '[app-case-footer]',
  templateUrl: './case-footer.component.html',
  styleUrls: ['./case-footer.component.css']
})
export class CaseFooterComponent {

}
